export const allSocialItemsStyle = {
	wrapper: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		gap: '12px',
		marginBottom: '24px',
	},

	icon: {
		width: '40px',
		height: '40px',
		borderRadius: '4px',
		border: '1px solid var(--neutral-200)',

		'&:hover': {
			border: '1px solid  var(--primary-500)',
		},
	},
};
